import React, { useRef } from "react";
import { DataGrid } from "devextreme-react/data-grid";
import ChartCard from "components/common/pyramid/ChartCard";

const LastFiveEvents = ({ data, userList, title }) => {
  const dataGridRef = useRef(null);

  // transform date to format yyyy-MM-dd
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  const formattedData = data
    ? data.map((item) => ({
        ...item,
        formattedDate: formatDate(item.createdAt),
      }))
    : [];

  const columns = [
    {
      dataField: "type",
      caption: "Event",
      alignment: "left",
      cellTemplate: (container, options) => {
        container.style.whiteSpace = "normal";
        container.textContent = options.text;
      },
    },
    {
      dataField: "userId",
      caption: "Performer",
      alignment: "left",
      width: 300,
      lookup: {
        dataSource: userList,
        valueExpr: "id",
        displayExpr: "displayName",
      },
      groupCellTemplate: (element, data) => element.append(data.text),
    },
    {
      dataField: "description",
      caption: "Description",
      alignment: "left",
      cellTemplate: (container, options) => {
        container.style.whiteSpace = "normal";
        container.textContent = options.text;
      },
    },
    {
      dataField: "formattedDate",
      caption: "Creation Date",
      alignment: "left",
      cellTemplate: (container, options) => {
        container.style.whiteSpace = "normal";
        container.textContent = options.text;
      },
    },
  ];

  return (
    <ChartCard
      title={title}
      className="pt-0 pb-3 ps-3 pe-3"
      dataGridRef={dataGridRef}
    >
      <DataGrid
        ref={dataGridRef}
        dataSource={formattedData}
        columns={columns}
        showBorders={true}
        showColumnLines={true}
        showRowLines={true}
        rowAlternationEnabled={true}
        allowColumnReordering={false}
        allowColumnResizing={false}
        columnAutoWidth={true}
        wordWrapEnabled={false}
        hoverStateEnabled={false}
        sorting={{ mode: "none" }}
        headerFilter={{ visible: false }}
      />
    </ChartCard>
  );
};

export default LastFiveEvents;
